import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO41 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK004-1.jpg"
      
      alt="Reserved avatar"

    />
  )
}

export default ImageMO41
